'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/ref.js
// module id = 677
// module chunks = 0